import { FileRejection, prettyBytes } from '@cad-arc';
import { MAX_UPLOAD_SIZE } from '../constants';

export function getFileRejectionErrorMessage(rejection: FileRejection): string {
    const file = rejection.file;
    const error = rejection.errors?.[0];

    if (error.code === 'file-too-large' && MAX_UPLOAD_SIZE) {
        const maxSize = prettyBytes(MAX_UPLOAD_SIZE);
        const actualSize = prettyBytes(file.size);
        return `File is too large (${actualSize}). Maximum file size is ${maxSize}.`;
    }

    return `Unable to upload "${file.name}". ${error.message || 'Unknown error occurred.'}`;
}
